var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 41.95L26.65 28.8C25.65 29.6667 24.4833 30.3417 23.15 30.825C21.8167 31.3083 20.4 31.55 18.9 31.55C15.3 31.55 12.25 30.3 9.75 27.8C7.25 25.3 6 22.2833 6 18.75C6 15.2167 7.25 12.2 9.75 9.70001C12.25 7.20001 15.2833 5.95001 18.85 5.95001C22.3833 5.95001 25.3917 7.20001 27.875 9.70001C30.3583 12.2 31.6 15.2167 31.6 18.75C31.6 20.1833 31.3667 21.5667 30.9 22.9C30.4333 24.2333 29.7333 25.4833 28.8 26.65L42 39.75L39.8 41.95ZM18.85 28.55C21.55 28.55 23.85 27.5917 25.75 25.675C27.65 23.7583 28.6 21.45 28.6 18.75C28.6 16.05 27.65 13.7417 25.75 11.825C23.85 9.90835 21.55 8.95001 18.85 8.95001C16.1167 8.95001 13.7917 9.90835 11.875 11.825C9.95833 13.7417 9 16.05 9 18.75C9 21.45 9.95833 23.7583 11.875 25.675C13.7917 27.5917 16.1167 28.55 18.85 28.55Z",
    fill: "#DFDFDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGray);
export default __webpack_public_path__ + "static/media/search_gray.495c20d396b45dd29eb80d1e03c5470a.svg";
export { ForwardRef as ReactComponent };